import { useMutation } from '@tanstack/react-query';
import {
  invalidateFlashbookDesigns,
  updateDesignsSortOrder,
} from '../../services/flashbooks';
import { UpdateDesignsSortOrderPayload } from '../../types/flashbooks';

interface Options {
  onSuccess?: () => void | Promise<void>;
  onError?: (error: unknown) => void | Promise<void>;
}

function useUpdateDesignsSortOrder({ onSuccess, onError }: Options = {}) {
  return useMutation({
    mutationFn: async ({
      flashbookId,
      payload,
    }: {
      flashbookId: string;
      payload: UpdateDesignsSortOrderPayload;
    }) => updateDesignsSortOrder({ flashbookId, payload }),
    onSuccess: async () => {
      await invalidateFlashbookDesigns();
      await onSuccess?.();
    },
    onError: async error => {
      await invalidateFlashbookDesigns();
      await onError?.(error);
    },
  });
}

export default useUpdateDesignsSortOrder;
